import { graphql } from '@api/generated';

export const updateUserMutation = graphql(`
  mutation UpdateUser(
    $userId: ID!
    $seatLevel: UserSeatLevel
    $inboundRecording: RecordingSettings
    $inboundAnnounceRecording: AnnounceRecordingStatus
    $outboundRecording: RecordingSettings
    $outboundAnnounceRecording: AnnounceRecordingStatus
    $phoneNumber: String
    $e911Address: AddressInput
    $ringingTimeout: String
    $sendVoicemailToEmail: Boolean
    $billToTenantId: Long
  ) {
    updateUser(
      userId: $userId
      input: {
        seatLevel: $seatLevel
        inboundRecording: $inboundRecording
        inboundAnnounceRecordingSettings: $inboundAnnounceRecording
        outboundRecording: $outboundRecording
        outboundAnnounceRecordingSettings: $outboundAnnounceRecording
        phoneNumber: $phoneNumber
        e911Address: $e911Address
        ringingTimeout: $ringingTimeout
        sendVoicemailToEmail: $sendVoicemailToEmail
        billToTenantId: $billToTenantId
      }
    ) {
      id
      seatLevel
      billToTenantId
      billToTenant {
        id
        name
      }
      ...UserDetailPersonalLine
      ...UserDetailRecording
    }
  }
`);

export const addUserQueueMutation = graphql(`
  mutation AddUserQueue($userId: ID!, $queueId: ID!) {
    addUserQueue(userId: $userId, queueId: $queueId) {
      id
      ...UserDetailQueues
    }
  }
`);

export const addUserQueuesMutation = graphql(`
  mutation AddUserQueues($userId: ID!, $queueIds: [ID!]!) {
    addUserQueues(userId: $userId, queueIds: $queueIds) {
      id
      ...UserDetailQueues
    }
  }
`);

export const bulkAddUserQueuesMutation = graphql(`
  mutation BulkAddUserQueues($userIds: [ID!]!, $queueIds: [ID!]!) {
    bulkAddUserQueues(userIds: $userIds, queueIds: $queueIds) {
      successes {
        id
        ...UserDetailQueues
      }
      errors {
        id
        error
      }
    }
  }
`);

export const removeUserQueueMutation = graphql(`
  mutation RemoveUserQueue($userId: ID!, $queueId: ID!) {
    removeUserQueue(userId: $userId, queueId: $queueId) {
      id
      ...UserDetailQueues
    }
  }
`);

export const bulkRemoveUserQueuesMutation = graphql(`
  mutation BulkRemoveUserQueues($userIds: [ID!]!, $queueIds: [ID!]!) {
    bulkRemoveUserQueues(userIds: $userIds, queueIds: $queueIds) {
      successes {
        id
        ...UserDetailQueues
      }
      errors {
        id
        error
      }
    }
  }
`);

export const UPDATE_USER_QUEUE_MUTATION = graphql(`
  mutation UpdateUserQueue(
    $userId: ID!
    $queueId: ID!
    $input: UserQueueUpdateInput!
  ) {
    updateUserQueue(userId: $userId, queueId: $queueId, input: $input) {
      id
      ...UserDetailQueues
    }
  }
`);

export const bulkUpdateUserMutation = graphql(`
  mutation BulkUpdateUser($inputs: [BulkIndividualUserUpdateInput!]!) {
    bulkUpdateUser(inputs: $inputs) {
      successes {
        id
        seatLevel
        billToTenantId
        billToTenant {
          id
          name
        }
        queues {
          id
          name
        }
        ...UserDetailPersonalLine
        ...UserDetailRecording
      }
      errors {
        id
        error
      }
    }
  }
`);
